import { drugsActions } from '../../../../redux/actions/medication/drugs/drugs';

const initialState = {
  drugs: [], // List of all drugs
  drug: null, // Details of a single drug
  loading: false, // Loading state
  error: null // Error state
};

/**
 * Reducer to handle drug-related actions.
 * @param {Object} state - Current state.
 * @param {Object} action - Dispatched action containing type and payload.
 * @returns {Object} - New state based on the action type.
 */
const drugsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch All Drugs
    case drugsActions.FETCH_DRUGS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case drugsActions.FETCH_DRUGS.SUCCESS:
      return {
        ...state,
        loading: false,
        drugs: action.payload
      };

    case drugsActions.FETCH_DRUGS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

      // Fetch Drug by ID
    case drugsActions.FETCH_DRUG_BY_ID.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case drugsActions.FETCH_DRUG_BY_ID.SUCCESS:
      return {
        ...state,
        loading: false,
        drug: action.payload
      };

    case drugsActions.FETCH_DRUG_BY_ID.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case drugsActions.DELETE_DRUG.REQUEST:
      return {
        ...state,
        loading: true
      };

    case drugsActions.DELETE_DRUG.SUCCESS:
      return {
        ...state,
        loading: false,
        drugs: state.drugs.filter((drug) => drug.id !== action.payload.id)
      };

    case drugsActions.DELETE_DRUG.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

      // Default case
    default:
      return state;
  }
};

export default drugsReducer;
